import { t } from "./coachTokens";

export const weightTrendStr = (trend) => {
  if (trend == null) return "–";
  if (trend > 0) return `↑ ${trend.toFixed(1)} ק"ג`;
  if (trend < 0) return `↓ ${Math.abs(trend).toFixed(1)} ק"ג`;
  return `0 ק"ג`;
};

export const weightGoalDirInfo = (d) => {
  if (!d?.weightGoalDirection || d.weightTargetMin == null || d.weightTargetMax == null) return null;
  return { dir: d.weightGoalDirection, min: d.weightTargetMin, max: d.weightTargetMax };
};

export const weightGoalLabel = (d) => {
  const g = weightGoalDirInfo(d);
  if (!g) return null;
  if (g.dir === "loss") return `יעד: ירידה ${Math.abs(g.max)}-${Math.abs(g.min)} ק"ג`;
  if (g.dir === "gain") return `יעד: עלייה ${g.min}-${g.max} ק"ג`;
  return "יעד: ריקומפ";
};

export const weightGoalMet = (d) => {
  const g = weightGoalDirInfo(d);
  if (!g || d.weightTrend == null) return null;
  const lo = Math.min(g.min, g.max);
  const hi = Math.max(g.min, g.max);
  return d.weightTrend >= lo && d.weightTrend <= hi;
};

export const weightTrendColor = (d) => {
  const met = weightGoalMet(d);
  if (met == null) return t.t3;
  return met ? t.green : t.red;
};

export const seriesDelta = (series) => {
  if (!Array.isArray(series) || series.length < 2) return null;
  const first = series[0]?.value;
  const last = series[series.length - 1]?.value;
  if (first == null || last == null) return null;
  return last - first;
};

export const deltaDirOk = (delta, goalDir) => {
  if (delta == null) return null;
  if (!goalDir) return null;
  if (goalDir === "loss") return delta < 0;
  if (goalDir === "gain") return delta > 0;
  if (goalDir === "maintain") return Math.abs(delta) <= 0.5;
  return null;
};
